export const year = "2026";
export const programTime = "1/24/2026 from 7am-10pm";

export const docuSignLink =
  "https://powerforms.docusign.net/05020e8a-0954-4526-b2a0-9d188df6d732?env=na2&acct=a76475db-2ab3-4a5f-b7bd-1ba6a5dd7f4e&accountId=a76475db-2ab3-4a5f-b7bd-1ba6a5dd7f4e&recipientLang=en";

export const formField: { [key: string]: string } = {
  A_student_address: "Text 2af4e304-ec39-4fe7-ac8d-4143b3478b49",
  A_parent_first: "Text 232a24ae-0755-459d-82b7-cc1c5e369cb3",
  A_parent_last: "Text d92bcfdc-7c55-4d03-b8f4-788adfa60d58",
  A_parent_middle: "Text f7038eca-486f-4e6f-96fe-e1a8b495c664",
  A_student_first: "Text 68aa83c3-d1f9-4331-8fc3-6c6da7158649",
  A_student_last: "Text 3cc2a130-554f-48ec-a30b-e1cad0427373",
  A_student_middle: "Text f2fc79b2-5178-4a3c-893c-cb9f6b10af50",
  A_student_birthday: "Text 765e56a8-7033-4e8a-8bfd-d871a9d52b78",
  A_parent_phone: "Text a7ef29fe-1678-40e1-b2c4-5561bedb5a08",
  B_parent_name: "Text d4c967d4-7aa5-4566-bf15-b1e0d57a3bbc",
  C_student_name: "Text bb9a7abc-e395-4e86-ab7f-9c54ccb44f56",
  D_parent_address: "Text 3095da8b-32c8-4910-99bb-5962718908ed",
  D_student_name: "Text a0e06c49-a3d6-4d5b-b81a-3c8e2f1bc230",
  A_program_name: "Text e596ef36-2223-4a79-ae30-15f2490af9a9",
  A_program_time: "Text 1670f440-0440-440b-a535-2532021e71f4",
};

export const schoolList = [
  "Academy of the Pacific Rim Charter Public School",
  "Acton Boxborough Regional High School",
  "Adlai E. Stevenson High School",
  "Ann Arbor Pioneer High School",
  "Archimedean Upper Conservatory",
  "Arlington High School",
  "BASIS Cedar Park Charter School",
  "Belmont High School",
  "Boca Raton High School",
  "Boston Latin School",
  "Boston University Academy",
  "Cambridge Rindge and Latin School",
  "Chattahoochee High School",
  "Chelmsford High School",
  "Clements High School",
  "Cumberland Valley High School",
  "Enloe Magnet High School",
  "Fairfield County Homeschoolers",
  "Falmouth High School",
  "Harriton High School",
  "Holliston High School ",
  "Hopkinton High School",
  "Iolani School",
  "Jericho High School",
  "Jordan High School",
  "Lexington High School",
  "Liberal Arts and Science Academy",
  "Madison West High School",
  "Malden High School",
  "Marquette University High School",
  "Mason High School",
  "Merrimack High School",
  "Monta Vista High School",
  "Montgomery High School",
  "Mountain House High School",
  "Mountain View High School",
  "Nashua High School North",
  "New Trier High School",
  "Newton South High School",
  "Northwood High School",
  "Novi High School",
  "Old Rochester Regional High School",
  "Phillips Exeter Academy",
  "Pilgrim High School",
  "Princeton International School of Mathematics and Science",
  "Scarsdale High School",
  "Seven Lakes High School",
  "South Windsor High School",
  "Stuyvesant High School",
  "Syosset High School",
  "The Winsor School",
  "Troy High School",
  "Uxbridge High School",
  "Walpole High School",
  "Waterville Senior High School",
  "West Windsor Plainsboro High School North",
  "Westborough High School",
  "Wilbraham & Monson Academy",
  "Winchester High School",
];
